import React, { useContext, useEffect, useState } from "react";
import { ConfigurationContext, StepsContext } from "contexts";
import ScanErrorNetwork from "./ScanErrorNetwork";
import TimeoutApp from "./TimeoutApp";
import TimeoutNetwork from "./TimeoutNetwork";
import TimeoutExtension from "./TimeoutExtension";
import MessageCancelApp from "./MessageCancelApp";
import Success from "./Success";
import Error from "./Error";
import { Cookie } from "utilities";

/**
 *  Drop the computer ID cookie.
 *  @param {object} config - All the configuration settings.
 */
const dropCookie = (config) => {
  //  if (config.referrerID.toString() === "1046") {

  // Referrer is CYRI.
  //  let cookie = Cookie.cyriCookie(config.computerID);
  //  cookie.clear();
  //  cookie.set();

  // console.log(`Cookie cyri is: ${cookie.value}`);
  //} //else {
  // All other referrers.
  let cookie = Cookie.clientCookie(config.computerId, config.referrerId);

  // cookie.clear(); // This is probably not necessary. Just overwrite the cookie.
  cookie.set();

  //  console.log(`Cookie is: ${cookie.value}`);
  //}
};

/**
 * Finish step component.
 *
 */

const StepFinish = () => {
  let config = useContext(ConfigurationContext);
  let [steps] = useContext(StepsContext);

  //  State can be:
  //    1. success - Successful detection.
  //    2. cancelApp - Application has been canceled.
  //    3. timeoutApp - Application detection ran out of time.
  //    4. timeoutExtension - Extension detection ran out of time.
  //    5. scanErrorNetwork - Network scan had a problem.
  //    6. timeoutNetwork - Network scan timed out.

  const [state, setState] = useState({});

  // Set up the initial state.
  useEffect(() => {
    if (steps.state.appDetection.cancelError) {
      setState({ cancelApp: true });
    } else if (steps.state.appDetection.timeoutError) {
      setState({ timeoutApp: true });
    } else if (steps.state.appDetection.timeoutErrorExtension) {
      setState({ timeoutExtension: true });
    } else if (steps.state.networkDetection.scanError) {
      setState({ scanErrorNetwork: true });
    } else if (steps.state.networkDetection.timeoutError) {
      setState({ timeoutNetwork: true });
    } else {
      setState({ success: true });
      // No errors so leave.
      if (config.next) {
        setTimeout(() => {
  //        console.log(`dropped cookie to ${config.computerId} and ${config.referrerId}`);
          dropCookie(config);
          if (config.next && config.next.length > 0) {
            window.location = config.next;
          }
        }, 10);
      }
    }
  }, []);

  /**
   *  Retry handler. Restart the app.
   */
  const onRetry = () => {
    // Refresh page.
    window.location.reload();
  };

  /**
   *  Continue handler. Push onto the error location.
   */
  const onContinue = () => {
    // Go to error page or back to origin or wherever.

    // TODO: This probably should delete any cookie that may have been set already. This is an error in detection.

    window.location = config.error;
  };

  return (
    <>
      {state.cancelApp && (
        <Error onRetry={onRetry} onContinue={onContinue}>
          <MessageCancelApp />
        </Error>
      )}
      {state.timeoutApp && (
        <Error onRetry={onRetry} onContinue={onContinue}>
          <TimeoutApp />
        </Error>
      )}
      {state.timeoutExtension && (
        <Error onRetry={onRetry} onContinue={onContinue}>
          <TimeoutExtension />
        </Error>
      )}
      {state.timeoutNetwork && (
        <Error onRetry={onRetry} onContinue={onContinue}>
          <TimeoutNetwork />
        </Error>
      )}
      {state.scanErrorNetwork && (
        <Error onRetry={onRetry} onContinue={onContinue}>
          <ScanErrorNetwork />
        </Error>
      )}
      {state.success && <Success onRetry={onRetry} onContinue={onContinue} />}
    </>
  );
};

export default StepFinish;
